import { render, staticRenderFns } from "./loading-icon.vue?vue&type=template&id=30e351ba&"
import script from "./loading-icon.vue?vue&type=script&lang=js&"
export * from "./loading-icon.vue?vue&type=script&lang=js&"
import style0 from "./loading-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports